module.exports = __webpack_public_path__ + "static/media/mobileFlash.3ebc96f9.mp3";